//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: '',
  props: {
    value: {
      type: String
    },
    showDelete: {
      type: Boolean,
      "default": false
    },
    text: {
      type: String,
      "default": '上传图片'
    }
  },
  watch: {
    value: function value(n, o) {
      this.url = this.value;
    }
  },
  data: function data() {
    return {
      url: this.value,
      tips: this.text
    };
  },
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    handleAvatarSuccess: function handleAvatarSuccess(res, file) {
      var _this = this;

      if (res.code === 0) {
        this.url = URL.createObjectURL(file.raw);
        setTimeout(function () {
          _this.url = res.url;

          _this.$emit("update", _this.url);
        }, 300);
      } else {
        this.$messgae.error(res.msg);
      }
    },
    onDealImage: function onDealImage() {
      var _this2 = this;

      this.$confirm('确认删除图片吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this2.url = '';

        _this2.$emit("update", _this2.url);
      })["catch"](function () {});
    }
  }
};